import { GlBadge, GlPopover } from '@gitlab/ui';
export default {
    name: 'ImmutableBadge',
    components: {
        GlBadge,
        GlPopover
    },
    props: {
        tag: {
            type: Object,
            required: true
        },
        tagRowId: {
            type: String,
            required: true
        }
    },
    computed: {
        isImmutable () {
            return this.tag.protection?.immutable;
        }
    }
};
